/**
 * Resolves a bucket folder item ID from an env var formatted as:
 * SiteName:{guid}|OtherSite:{guid}
 */
export const getBucketFolderIdForSite = (
  envValue: string | undefined,
  siteName: string
): string => {
  if (!envValue) {
    return '';
  }

  const siteEntry = envValue.split('|').find((item) => {
    const [name] = item.split(':');
    return name?.toLowerCase() === siteName?.toLowerCase();
  });

  if (!siteEntry) {
    return '';
  }

  const [, folderId] = siteEntry.split(':');
  return folderId ?? '';
};
